import base from './base.repository';

export default {
    ...base,
    getTasks(filters, page){
        const params = {...filters, page: page};
        this.get(`tasks${this.querify(params)}`);
        return this;
    },
    getCreators(){
        this.get(`tasks/creators`);
        return this;
    },
    getAssignedUsers(){
        this.get(`tasks/assigned-users`);
        return this;
    },
    //por usuario que creo la tarea
    getTasksByUser(userId, filters, page){
        const params = {...filters, page: page, user: userId};
        this.get(`tasks${this.querify(params)}`);
        return this;
    },
    //tareas por el usuario asignado
    getTasksByAssigned(userId, filters, page){
        const params = {...filters, page: page, assignee: userId};
        this.get(`tasks${this.querify(params)}`);
        return this;
    },
    getTasksToObserveByUser(userId, filters, page){
        const params = {...filters, page};
        this.get(`tasks/to-observe/by-user/${userId}${this.querify(params)}`);
        return this;
    },
    saveTask(payload){
        this.post('tasks', payload);
        return this;
    },
    updateTask(payload, id) {
        this.put('tasks/' + id, payload);
        return this;
    },
    deleteTask(id){
        this.delete(`tasks/${id}`);
        return this;
    },
    saveNoteTask(note){
        this.post('tasks/save-note', note);
        return this;
    },
    updateNoteTask(payload, id) {
        this.put('tasks/update-note/' + id, payload);
        return this;
    },
    deleteNoteTask(id){
        this.delete(`tasks/delete-note/${id}`);
        return this;
    },
    markResolvedTask(id, payload){
        this.post(`tasks/${id}/mark-resolved`, payload);
        return this;
    },
    uploadFiles(formData){
        this.post('tasks/upload-files', formData);
        return this; 
    },
    approveTask(id, payload){
        this.post(`tasks/${id}/approve`, payload);
        return this;
    },
    rejectTask(id, payload){
        this.post(`tasks/${id}/reject`, payload);
        return this;
    },
    deleteWatcher(id){
        this.delete(`tasks/watcher/${id}`);
        return this;
    },
    assignTaskWatchers(payload){
        this.post('tasks/assign-watchers', payload);
        return this;
    },
}